import * as React from "react";
const SuccessTickIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m5.827 9.289 1.616 2.381 4.729-5.34"
      data-name="Path 705"
    />
    <g fill="none" stroke="currentColor" strokeWidth={2} data-name="Ellipse 66">
      <circle cx={9} cy={9} r={9} stroke="none" />
      <circle cx={9} cy={9} r={8} />
    </g>
  </svg>
);

export default SuccessTickIcon;
